import { render, staticRenderFns } from "./PanelItem.vue?vue&type=template&id=11282908&scoped=true&"
import script from "./PanelItem.vue?vue&type=script&lang=js&"
export * from "./PanelItem.vue?vue&type=script&lang=js&"
import style0 from "./PanelItem.vue?vue&type=style&index=0&id=11282908&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11282908",
  null
  
)

export default component.exports